/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "566")
  

// 接口文档



export interface API77582Req {
  
  /** 文件地址 */
  fileUrl?: string;
};



export interface API77582Res {
  /**   */
  taskId?: string;
  
};


// 接口函数 77582 上传语音文件

export interface IUsePostAPI77582Return {
  /** 上传语音文件: 接口请求状态 */
  isAPI77582Loading: boolean;
  /** 上传语音文件: 接口请求返回数据 */
  dataAPI77582: API77582Res;
  /**  上传语音文件: 接口数据请求方法 */
  fetchAPI77582Data: (inputs: API77582Req, config?: YWRequestConfig) => Promise<API77582Res>;
  /** 上传语音文件: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77582 = ():IUsePostAPI77582Return => {
  let isMount = true;
  const [isAPI77582Loading, setIsAPI77582Loading] = useState(false);
  const [dataAPI77582, setDataAPI77582] = useState<API77582Res>({} as API77582Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/uploadVoiceFile`;

  const fetchAPI77582Data = async (inputs: API77582Req, config?: YWRequestConfig): Promise<API77582Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77582Req>) || {}) as API77582Req;
    
  
    if ( isMount ) {
      setIsAPI77582Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77582Res>(`${basePath}/yoaichat-admin/chat/uploadVoiceFile`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77582(res || {} as API77582Res);
        setIsAPI77582Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77582Loading(false);
      }
      return false as unknown as API77582Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77582Loading,
    dataAPI77582,
    fetchAPI77582Data,
    requestUrl,
  }
}

